/**
 * Unwrap race CSV file metadata from events API responses
 * (GET meta and equivalent nested shapes).
 */
export function extractRaceCsvFileMeta(res: unknown): Record<string, unknown> | null {
  const r = res as { data?: unknown; ok?: boolean } | null;
  if (r && r.ok === false) return null;
  const data = (r?.data ?? r) as Record<string, unknown> | null;
  if (!data || typeof data !== 'object') return null;
  if (data.file && typeof data.file === 'object') return data.file as Record<string, unknown>;
  if (data.latest && typeof data.latest === 'object') return data.latest as Record<string, unknown>;
  const files = data.files;
  if (Array.isArray(files) && files.length && typeof files[0] === 'object') {
    return files[0] as Record<string, unknown>;
  }
  if (data.fileId || data.s3Key || data.fileName) return data;
  return null;
}

/** @deprecated Use extractRaceCsvFileMeta */
export const extractAthleteAssignmentsFileMeta = extractRaceCsvFileMeta;

/** Row count from athletes.csv metadata (not device-package-assignments). */
export function extractAthletesRosterRowCount(res: unknown): number | null {
  const meta = extractRaceCsvFileMeta(res);
  if (!meta) return null;
  const raw = meta.rowCount;
  if (typeof raw === 'number' && Number.isFinite(raw) && raw >= 0) return raw;
  if (typeof raw === 'string' && raw.trim()) {
    const n = Number(raw);
    if (Number.isFinite(n) && n >= 0) return n;
  }
  return null;
}
